import {
  Tool,
  type ToolArgs,
  AhaEditorUtils,
  Guards,
  slate,
} from '@aha-app/aha-editor-v2';
import { askConfirmation } from 'components/common/Confirm';

class ToolDeleteWhiteboard extends Tool {
  static toolName = 'Delete';
  static iconClass = 'fa-solid fa-trash';

  static async action({ editor }: ToolArgs): Promise<void> {
    const whiteboards = slate.Editor.above(editor, {
      match: Guards.isEmbeddedWhiteboardElement,
    });

    if (!whiteboards) return;
    const whiteboard = whiteboards[0];

    const confirmed = await askConfirmation({
      body: 'Are you sure you want to delete this whiteboard?',
      confirmText: 'Yes, delete this whiteboard',
      title: 'Warning',
    });

    if (confirmed) {
      AhaEditorUtils.Transforms.removeNodeByElement(editor, whiteboard);
    }
  }
}

export default ToolDeleteWhiteboard;
